import React from "react";
import PropTypes from 'prop-types';
import graphql from 'babel-plugin-relay/macro';
import {QueryRenderer} from 'react-relay';

import ChangerComponent from './ChangerComponent';
import {StateContext} from '../context';

const Changer = ({classes, ...other}) => {

    return (
        <QueryRenderer
          environment = { other.environment || (other.relay && other.relay.environment) }
          query = { graphql`
            query ChangerOrgQuery($name: String) {
              authorizedOrgs(name: $name) {
                ...ChangerComponent_orgs
              }
            }
            `
          }
          variables = {{
            name:"",
          }}
          render={({ error, props }) => {
            if (Boolean(error)) { return <div>{error}</div> }
            else if (props) { return (
                <ChangerComponent {...other} orgs = {props.authorizedOrgs}/>
              )
            }
            else { return <div>loading...</div> }
          }}
    />)
}
export default React.memo(Changer)
